import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { zfd } from 'zod-form-data'
import { ModelContactList } from './contactList'
import { type ModelOrganization } from './organization'
import { type ModelUser } from './user'
import { regexEmail, regexPhone } from './utils'

export type Contact = {
  _id: string
  tid: string
  created: string
  modified: string
  deleted?: boolean
  deletedDate?: string
  organization: ModelOrganization
  slug: string
  firstName: string
  lastName: string
  email: string
  phone?: string
  source: string //'form' | 'manual' | 'import'
  user: Omit<ModelUser, 'group' | 'role'> // broker
  relatedUser?: ModelUser

  companyName?: string
  notes?: string
  // contactLists?: { _id: string; tid: string; slug: string; name: string }[]
  contactLists?: ModelContactList[]
}

export type ActivityContact = {
  _id: string
  tid: string
  slug: string
  firstName: string
  lastName: string
  email?: string
  phone?: string
  organization: string
}

export type CookieContact = Pick<
  ActivityContact,
  'firstName' | 'lastName' | 'email' | 'phone'
>

export type ImportContactData = {
  First: string
  Last: string
  Email: string
  Phone?: string
  Company?: string
}

export const ContactSchema = z.object({
  _id: z.string(),
  tid: z.string(),
  created: z.string(),
  modified: z.string(),
  deleted: z.boolean().optional(),
  deletedDate: z.string().optional(),
  organization: z.custom<ModelOrganization>(),
  slug: z.string(),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().refine((val) => regexEmail(val), {
    message: 'Please enter a valid email.',
  }),
  // .min(1, 'Please enter an email')
  phone: z
    .string()
    .optional()
    .refine((val) => regexPhone(val), {
      message: 'Please enter a valid phone number.',
    }),
  source: z.string(),
  user: z.custom<ModelUser>(),
  relatedUser: z.custom<ModelUser>().optional(),
  companyName: zfd.text(z.string().optional()),
  notes: zfd.text(z.string().optional()),
  contactLists: zfd
    .repeatable(
      z.array(
        z.object({
          _id: zfd.text(z.string()),
          tid: zfd.text(z.string()),
          slug: zfd.text(z.string()),
          name: zfd.text(z.string()),
        })
      )
    )
    .optional()
    .default([]),
}) satisfies z.ZodType<Contact>

export const contactValidator = withZod(ContactSchema)

export const BrokerContactFormSchema = z.object({
  _id: z.string(),
  firstName: z.string().min(1, 'Please enter your first name'),
  lastName: z.string().min(1, 'Please enter your first name'),
  email: z
    .string()
    .min(1, 'Please enter your email')
    .email('Please enter a valid email')
    .optional(),
  phone: z.string().optional(),
  message: z.string().optional(),
  fileId: z.string().optional(),
})

export const brokerContactValidator = withZod(BrokerContactFormSchema)
